<template>
  <div class="dashboard">
    <!-- v-if="this.$store.state.user.user" -->
    <v-container>
      <v-row>
        <v-col cols="12" md="4" v-for="item in items" :key="item.nombre">
          <v-card class="mx-auto" outlined>
            <v-list-item class="pa-5">
              <v-list-item-avatar>
                <v-icon class="secondary lighten-1" dark>
                   mdi-{{ item.icon }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-left headline mb-1">
                  {{ item.nombre }}
                </v-list-item-title>
              </v-list-item-content>


                <span class="primary--text headline font-weight-bold">{{
                  item.items
                }}</span>

            </v-list-item>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              
	<v-btn text right color="secondary" :to="`/areas/${item.id}`">
                ver area
              </v-btn>
          
             <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="edit(item)"                
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>     
              
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="datele(item, 'INACTIVE', true)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      
      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-container>
    
    
    <delete
      :active.sync="activeDelete"
      :id="currentArea.id"
      :name="currentArea.nombre"
    ></delete>
    
      <!-- Button active dialog / create record-->
    <v-btn
      class="mx-2"
      fab
      dark
      bottom
      fixed
      right
      color="secondary"
      @click="open"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
    
    
    
     <!-- Create or edit area dialog -->
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ currentArea ? "Editar area" : "Crear area" }}

        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4">
          <v-form ref="formArea" v-model="validForm" lazy-validation>


            <v-text-field
              v-model="model.nombre"
              :rules="[this.$store.state.rules.required]"
              label="Nombre"
              required

            ></v-text-field>
            
            <v-text-field
              v-model="model.icon"

              label="Icono (opcional)"
             
            ></v-text-field>
            
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text class="mr-4" small @click="clear">
            Cancelar
          </v-btn>

          <v-btn
            :disabled="!validForm"
            color="success"
            class="mr-4"
            small
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */

import { SET_AREAS } from "@/store/areas";
import Delete from "@/components/area/Delete";

export default {
  name: "Areas",
  components: {
    Delete,
  },
  filters: {

  },
  data: () => ({
    search: "",
    items: {},
    headers: [
      {
        text: "Nombre",
        align: "start",
        filterable: false,
        value: "nombre",
      },          
      { text: "Usuarios", value: "items", filterable: false },
      { text: "Acciones", value: "actions", filterable: false },
    ],
    pagination: {
      current: 0,
      total: 0,
    },
    validForm: true,
    dialog: false,
    activeDelete: false,    
    currentArea: false,
    model: {
      nombre: "",
      icon: "",
    },
    
  }),
  created() {
    this.$store.dispatch("getAreas");
    console.log(this.$store.state);
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_AREAS) {
      this.items = this.$store.state.areas.areas.data;
      
        this.pagination.current = state.areas.areas.current_page;
        this.pagination.total = state.areas.areas.last_page;
      }
    });
  },

  methods: {
    show(id) {
      window.open(`/areas/${id}`, '_blank').focus();      
    },
    
     save() {
      if (!this.$refs.formArea.validate()) return;

      if (this.currentArea) {


        this.$store.dispatch("updateArea", {
          form: this.model,
          id: this.currentArea.id,
        });
      } else {
        this.$store.dispatch("createArea", this.model);
      }
      this.clear();
    },
    
    clear() {
      this.dialog = false;
      this.model = {
        nombre: "",
        icon: "",
      };
      this.$refs.formArea.resetValidation();
      this.currentArea = false;
    },
    
     open() {
      this.dialog = true;
    },
    
    edit(area) {
      this.currentArea = area;
      console.log(area);
      
      this.model = {
        nombre: area.nombre,
        icon: area.icon,

      };
      this.open();
    },
    nextPage() {
      this.$store.dispatch("nextPageAreas", this.pagination.current);
    },
    datele(item) {
    console.log(item);
    
      this.currentArea = item;
      this.activeDelete = true;
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
